export default __webpack_public_path__ + "static/media/top.e20186d3.gif";